var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.gridPics),function(sec,index){return _c('b-row',{key:index},_vm._l((sec.pics),function(pic,index){return _c('b-col',{key:index,attrs:{"lg":"3","md":"3"}},[_c('b-img',{staticClass:"gridP imgW",attrs:{"src":require('@/assets/social/' + pic.img)}})],1)}),1)}),_c('b-row',[_c('b-col')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }